import { useEffect, useState } from 'react';
import { GraphBehavior, GraphMode } from 'ui/workflows/flowchart/constants';
import { Node } from 'modules/workflows/types';
import { EdgeModel, ItemData, NodeModel } from 'ui/workflows/flowchart/types';
import { FlowChart, FlowZoom, useFlowChart } from 'ui/workflows/flowchart';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { FLOWCHART_Z_INDEXES } from '../WorkflowFlowchart/WorkflowFlowchart.styles';

const ZoomControlsWrapper = styled.div`
  z-index: ${FLOWCHART_Z_INDEXES.TOOLBAR};
  position: absolute;
  bottom: 0;
  /** this allows the zoom controls to sit inside the canvas */
  margin-left: ${pxToRem(8)};
`;

const ZoomControls = ({ nodes }: { nodes: Node[] }) => {
  const { graph, center, zoomTo, fitView } = useFlowChart();
  const [zoomSet, setZoomControls] = useState(false);

  useEffect(() => {
    if (!graph || !nodes?.length) return setZoomControls(false);

    setZoomControls(true);
    if (nodes?.length === 1) {
      zoomTo(1);
      center();
    } else {
      fitView();
    }
  }, [nodes]);

  if (!zoomSet) return null;
  return (
    <ZoomControlsWrapper>
      <FlowZoom />
    </ZoomControlsWrapper>
  );
};

const NodeSelect = ({ selected }: { selected: string }) => {
  const { graph, unselect } = useFlowChart();

  useEffect(() => {
    if (graph && selected) unselect(selected);
  }, [graph, selected]);

  return null;
};

type JourneyPreviewProps = {
  nodes: Node[];
  edges: EdgeModel[];
  width?: number;
  height?: number;
};

export const JourneyPreview = ({
  nodes,
  edges,
  width = 600,
  height = 365,
}: JourneyPreviewProps) => {
  const [selectedNode, setSelectedNode] = useState('');
  const handleNodeSelect = (selected: ItemData) => {
    setSelectedNode(selected?.id);
  };

  return (
    <FlowChart
      data-test={'preview-flowchart'}
      width={width}
      height={height}
      nodes={nodes as NodeModel[]}
      edges={edges}
      graphOptions={{
        fitViewPadding: [20, 0, 20, 40],
        modes: {
          [GraphMode.Readonly]: [GraphBehavior.DragCanvas, GraphBehavior.ScrollCanvas],
        },
      }}
      isReadOnly={true}
      isOverlayVisible={false}
      onNodeDblClick={handleNodeSelect}
    >
      <NodeSelect selected={selectedNode} />
      <ZoomControls nodes={nodes} />
    </FlowChart>
  );
};
